import { CreateUserProfileFormScheme } from '../../schemas/user.schema'
import { CurrentUserObject } from '../../api/types/user.interfaces'

const PERSONAL_DOMAINS = new Set([
	'gmail.com',
	'googlemail.com',
	'yahoo.com',
	'yahoo.co.uk',
	'outlook.com',
	'hotmail.com',
	'live.com',
	'msn.com',
	'icloud.com',
	'me.com',
	'mac.com',
	'aol.com',
	'proton.me',
	'pm.me',
	'protonmail.com',
	'gmx.com',
	'gmx.de',
	'yandex.ru',
	'yandex.com',
	'zoho.com',
	'mail.com',
])

export function inferAccountTypeFromEmail(
	email?: string,
): 'personal' | 'organization' {
	if (!email || !email.includes('@')) return 'personal'
	const domain = email.split('@')[1]?.toLowerCase()
	return PERSONAL_DOMAINS.has(domain) ? 'personal' : 'organization'
}

export function extractDomainFromEmail(email?: string): string {
	if (!email || !email.includes('@')) return ''
	return email.split('@')[1] || ''
}

export function extractDomainStem(domain: string): string {
	return domain.split('.')[0] || ''
}

export function shouldRedirectToCreateProfile(
	currentUser?: CurrentUserObject | null,
): boolean {
	if (!currentUser?.id) return false

	const profileFirstName = currentUser.profile?.firstName

	const hasMissingProfileName =
		typeof profileFirstName !== 'string' || profileFirstName.trim().length === 0

	return hasMissingProfileName
}

// interface OrganizationData {
// 	name?: string
// 	slug?: string
// 	[key: string]: any
// }

interface MapFormValuesToUpdateProfileParams {
	formData: CreateUserProfileFormScheme
	timezone: string
}

export function mapFormValuesToUpdateProfile({
	formData,
	timezone,
}: MapFormValuesToUpdateProfileParams) {
	return {
		firstName: formData.firstName.trim(),
		lastName: formData.lastName.trim(),
		email: formData.email.trim(),
		phone: formData.phone.trim(),
		avatar: '',
		preferences: {
			timezone: timezone,
		},
		notifications: {},
	} as any
}

interface MapFormValuesToOrganizationDataParams {
	formData: CreateUserProfileFormScheme
}

export function mapFormValuesToOrganizationData({
	formData,
}: MapFormValuesToOrganizationDataParams) {
	return {
		name: (formData.organizationName || '').trim(),
		slug: (formData.organizationSlug || '').trim(),
		primarySector: formData.primarySector || '',
		contactEmail: formData.email.trim(),
		logo: '',
	}
}
